import React, { useEffect, useState } from 'react'
import axios from 'axios'

export default function Freelancers() {

  useEffect(() => {
    getFreelancers()
  }, [])

  const [users, setUsers] = useState([])

  const getFreelancers = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/freelance/get-freelancers`)
      .then((res) => {
        console.log(res.data)
        setUsers(res.data)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  return (
    <div>
      
      <h2 style={{textAlign:'center'}}>{users.length} freelance users</h2>
      <table className='user-table'>
        <tr>
          <th>First name</th>
          <th>Last name</th>
          <th>Email</th>
          <th>Points</th>
        </tr>

        {
          users.map((user, i) => {
            return(
              <tr key={i}>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.email}</td>
                <td>{user.points}</td>
              </tr>
            ) 
          })

        }
      </table>
    </div>
  )
}
